import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["fieldType"];
import React from "react";
import Label from "../../../Label";
import Legend from "../../../Legend";
import { FIELD_TYPES_USING_LEGEND } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
function FormFieldLabel(_ref) {
  var fieldType = _ref.fieldType,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return FIELD_TYPES_USING_LEGEND.includes(fieldType) ? /*#__PURE__*/_jsx(Legend, _extends({}, restProps)) : /*#__PURE__*/_jsx(Label, _extends({}, restProps));
}
export default FormFieldLabel;